import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [

  {
    label: 'Dashboard',
    icon: 'home',
    link: '/dashboard'
  },
  {
    label: 'EWALLET',
    isTitle: true
  },
  {
    label: 'Disbursement',
    icon: 'pocket',
    link: '/ewallet/disbursement-wallets'
  },
  {
    label: 'Collection',
    icon: 'dollar-sign',
    link: '/ewallet/collection-wallets'
  },
  {
    label: 'Masters',
    isTitle: true
  },

  {
    label: 'Country',
    icon: 'globe',
    link: '/masters/country',
  },
  {
    label: 'Currency',
    icon: 'dollar-sign',
    link: '/masters/currency',

  },
  {
    label: 'MSISDN',
    icon: 'mail',
    link: '/masters/msisdn',

  },
  {
    label: 'Loan Remainder',
    icon: 'alert-octagon',
    link: '/masters/remainders',

  },
  {
    label: 'Charges',
    icon: 'battery-charging',
    link: '/masters/charges',

  },
{
    label: 'Denomination',
    icon: 'minus',
    link: '/masters/denomination',

  },
  {
    label: 'Tier Slab Mapping',
    icon: 'layers',
    link: '/masters/tier-slab-mapping',

  },
  {
    label: 'Aggregator',
    icon: 'users',
    link: '/masters/aggregator',

  },
  {
    label: 'Trusted Tier Group',
    icon: 'shield',
    link: '/masters/trusted-tier-group',

  },
  {
    label: 'RFM Rules',
    icon: 'sliders',
    link: '/masters/rfm-rule',

  },
  {
    label: 'System Limits',
    icon: 'clock',
    link: '/masters/system-limit',

  },
  {
    label: 'Blacklisted Customers',
    icon: 'user-x',
    link: '/masters/blacklisted-customers',

  },
  {
    label: 'Bar / Unbar Customers',
    icon: 'shield-off',
    link: '/masters/bar-unbar',

  },
  {
    // Sits with the other customer-level controls rather than under Settings: it is a list of
    // customers, maintained by the same people who maintain Blacklisted and Bar/Unbar.
    label: 'Auto Sweep Exclusion',
    icon: 'slash',
    link: '/masters/auto-sweep-exclusion',
    wrapLabel: true,
  },
//   {
//     label: 'Email',
//     icon: 'mail',
//     subItems: [
//       {
//         label: 'Inbox',
//         link: '/apps/email/inbox',
//       },
//       {
//         label: 'Read',
//         link: '/apps/email/read'
//       },
//       {
//         label: 'Compose',
//         link: '/apps/email/compose'
//       },
//     ]
//   },
{
    label: 'AI Engine',
    isTitle: true
  },
  {
    label: 'Loan Eligibility',
    icon: 'award',
    link: '/ai-agent/loan-eligibility'
  },
  {
    label: 'Loan Information',
    icon: 'file-text',
    link: '/ai-agent/loan-history'
  },
  {
    label: 'Balance Enquiry',
    icon: 'dollar-sign',
    link: '/ai-agent/balance-enquiry'
  },
  {
    label: 'Manual Debt Collection',
    icon: 'pocket',
    link: '/ai-agent/manual-debt-collection'
  },
  {
    label: 'Credit Provision',
    icon: 'dollar-sign',
    link: '/ai-agent/credit-provision'
  },
  {
    label: 'Payment Collection',
    icon: 'pocket',
    link: '/ai-agent/payment-collection'
  },
{
    label: 'Collection Confirmation',
    icon: 'book-open',
    link: '/ai-agent/payment-collection-confirmation'
  },
  {
    label: 'Batch Testing',
    icon: 'layers',
    link: '/ai-agent/batch-testing'
  },







{
    label: 'User Management',
    isTitle: true
  },
{
    label: 'Users',
    icon: 'users',
    link: '/user-management/users',

  },
{
    label: 'Roles',
    icon: 'user-check',
    link: '/user-management/roles',

  },

  {
    label: 'Reports',
    isTitle: true
  },
{
    label: 'Agents',
    icon: 'users',
    link: '/reports/report-agent',

  },
{
    label: 'Merchants',
    icon: 'users',
    link: '/reports/report-merchant',

  },
{
    label: 'Subscriber',
    icon: 'users',
    link: '/reports/report-subscriber',
  },
{
    label: 'Loans',
    icon: 'book',
    link: '/reports/report-loan',
  },
  {
    label: 'Debt Collection Log',
    icon: 'book',
    link: '/reports/report-debtcollection',
  },
  {
    label: 'Consolidated Loan',
    icon: 'file-text',
    link: '/reports/report-consolidated-loan',
  },
  {
    label: 'Loan Eligibility Log',
    icon: 'award',
    link: '/reports/loan-eligibility',
  },
  {
    label: 'Loan Information Log',
    icon: 'info',
    link: '/reports/report-loan-information',
  },
  {
    label: 'File Transaction',
    icon: 'file',
    link: '/reports/file-transaction',
  },
  {
    label: 'Agent Transaction',
    icon: 'users',
    link: '/reports/agent-transaction',
  },
  {
    label: 'Merchant Transaction',
    icon: 'shopping-cart',
    link: '/reports/merchant-transaction',
  },
  {
    label: 'Subscriber Transaction',
    icon: 'phone',
    link: '/reports/subscriber-transaction',
  },
{
    label: 'Notifications',
    isTitle: true
  },
{
    label: 'Scheduled SMS',
    icon: 'smartphone',
    link: '/notification/scheduled-sms',
  },
{
    label: 'SMS Request',
    icon: 'smartphone',
    link: '/notification/sms-request',
  },
{
    label: 'Email Notification',
    icon: 'mail',
    link: '/notification/email-notification',
  },
{
    label: 'SUPPORT',
    isTitle: true
  },
{
    label: 'Loan Search',
    icon: 'search',
    link: '/support/loan-search',
  },
{
    label: 'Tickets',
    icon: 'file-text',
    link: '/support/tickets',
  },
{
    label: 'WHATSAPP',
    isTitle: true
  },
{
    label: 'WhatsApp Campaign',
    icon: 'message-circle',
    link: '/whatsapp/campaign',
  },
{
    // The opt-out list is a sibling rather than a tab inside the campaign screen: it is consulted
    // and edited outside of any one campaign, and burying it under a campaign would imply it only
    // applies there.
    label: 'Opt-Out List',
    icon: 'user-x',
    link: '/whatsapp/optout',
  },
{
    label: 'WhatsApp Reports',
    icon: 'bar-chart-2',
    link: '/whatsapp/reports',
  },

  // Its own heading rather than a nested subItems entry. Every section of this menu is flat under
  // an isTitle heading, and the sub-menu branch in sidebar.component.html has no live user - making
  // this the first would be the first exercise of an untested rendering path, for a section that
  // reads the same either way.
  {
    label: 'OPERATIONS',
    isTitle: true
  },
{
    label: 'eWallet Collection Queue',
    icon: 'inbox',
    link: '/operations/ledger-queue',
    wrapLabel: true,
  },

  {
    label: 'Configuration & Settings',
    isTitle: true
  },
{
    label: 'Settings',
    icon: 'settings',
    link: '/settings/settings',
  },
  // Placed as a sibling of Settings rather than nested: this menu is flat under its isTitle
  // headings, and subItems appears only in commented-out example code, so nesting here would be
  // the first live use of an unexercised rendering path.
{
    // Non-breaking spaces bind "Payment History &" and "Loyalty Eligibility" into two unbreakable
    // groups, leaving the space after the ampersand as the only place the line can break. Plain
    // spaces would let it wrap wherever it happened to fit, which reads as an accident.
    label: 'Payment History & Loyalty Eligibility',
    icon: 'trending-up',
    link: '/settings/payment-history-ladder',
    wrapLabel: true,
  },
];
